module.exports = __webpack_public_path__ + "static/media/undraw_selection_92i4.d2024432.svg";